import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Stato della ricerca locale di una sezione, precompilabile dalla ricerca globale con `?q=`.
 * Cosi un risultato globale porta nella sezione gia filtrata, senza duplicare la logica di ricerca.
 */
export function useSectionSearch() {
  const [params, setParams] = useSearchParams();
  const iniziale = params.get("q") ?? "";
  const [search, setSearch] = useState(iniziale);

  useEffect(() => {
    const dallUrl = params.get("q");
    if (dallUrl !== null) setSearch(dallUrl);
    // La chiave resta nell'URL solo per il primo caricamento: poi comanda il campo della sezione.
  }, [params]);

  function aggiorna(valore: string) {
    setSearch(valore);
    if (params.has("q")) {
      const prossimi = new URLSearchParams(params);
      prossimi.delete("q");
      setParams(prossimi, { replace: true });
    }
  }

  return [search, aggiorna] as const;
}
